import { render, staticRenderFns } from "./VehicleDetailAssignments.vue?vue&type=template&id=67731732"
import script from "./VehicleDetailAssignments.vue?vue&type=script&lang=js"
export * from "./VehicleDetailAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports